import useSWR from 'swr';

import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { IClinicApiKeyClinic } from 'interfaces/clinicApiKeys';

const useAssignableApiKeyClinics = () => {
  const clinicId = loadSelectedClinicId();

  const url = '/clinic-api-keys/assignable-clinics';

  const { data, error } = useSWR<IClinicApiKeyClinic[]>(
    clinicId ? [url, clinicId] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<IClinicApiKeyClinic[]>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
  };
};

export default useAssignableApiKeyClinics;
